// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wstncgluifpnevsejrwz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndzdG5jZ2x1aWZwbmV2c2Vqcnd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk2MTgyMjEsImV4cCI6MjA4NTE5NDIyMX0.n4JOqQGsCq2yHil-DTyZo9VwvWlrIc_jbH41Fv_bljQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});